import styled from 'styled-components';
import PoolSideSvg from '../../assets/amenities/poolside-bar.svg';

const PoolSideIcon = styled(PoolSideSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '2.4rem'};
  height: ${props => props.height || '2.4rem'};
  margin: ${props => props.margin};
`;

export default PoolSideIcon;
